import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0dc1944"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "countdown" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<svg class=\"circle icon-hgradient icon\" viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\" data-v-b0dc1944><circle cx=\"50\" cy=\"50\" r=\"50\" class=\"\" data-v-b0dc1944></circle><linearGradient id=\"my-cool-gradient\" x2=\"1\" y2=\"1\" data-v-b0dc1944><stop offset=\"0%\" stop-color=\"#f7e1a7\" data-v-b0dc1944></stop><stop offset=\"25%\" stop-color=\"#e83434\" data-v-b0dc1944></stop><stop offset=\"40%\" stop-color=\"#c13939\" data-v-b0dc1944></stop><stop offset=\"50%\" stop-color=\"#e83434\" data-v-b0dc1944></stop><stop offset=\"60%\" stop-color=\"#c13939\" data-v-b0dc1944></stop><stop offset=\"75%\" stop-color=\"#e83434\" data-v-b0dc1944></stop><stop offset=\"100%\" stop-color=\"#f7e1a7\" data-v-b0dc1944></stop></linearGradient></svg>", 1)

import { ref } from 'vue';
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'Countdown',
  props: {
    duration: {},
    callback: {}
  },
  setup(__props: any) {

const props = __props;

let counterValue = props.duration ? ref(props.duration) : ref(15);
const intervalId = setInterval(() => {
  counterValue.value = counterValue.value - 1;
  console.info('counterValue:', counterValue);
  // this.$data.counterValue = this.$data.counterValue -1 ;
  if (counterValue.value === 0) {
    clearInterval(intervalId);
    if (props.callback) {
      props.callback();
    }
  }
}, 1000);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_unref(counterValue)), 1),
    _hoisted_2
  ]))
}
}

})